import { styled } from "@mui/material/styles";
import Page from "../components/Page";

export const RootStyle = styled(Page)(({ theme }) => ({
    [theme.breakpoints.up("md")]: {
        display: "flex",
    },
}));
